// extracted by mini-css-extract-plugin
export var downArrow = "_8v-0";
export var infoTooltipIcon = "_8v-3";
export var label = "_8v-1";
export var optionCard = "_8v-4";
export var upArrow = "_8v-2";